
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 36 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M0 0h36v24H0z"}}),_c('g',{attrs:{"fill":"#005293"}},[_c('g',{attrs:{"id":"c","transform":"translate(9 6)"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"id":"a","d":"M0-3v3h1.5z","transform":"rotate(18 0 -3)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"scale(-1 1)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(72)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(144)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(216)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(288)"}})]),_c('path',{attrs:{"d":"M0 12h18v12H0z"}})]),_c('g',{attrs:{"fill":"#d21034"}},[_c('path',{attrs:{"d":"M18 0h18v12H18z"}}),_c('use',{attrs:{"xlink:href":"#c","x":"18","y":"12"}})])])
          )
        }
      }
    